import { useState, useMemo, useCallback, useRef } from 'react';
import { SelectableListOption } from 'src/components/SelectableList/SelectableList';

export const useItemsSelection = (optionsMap: Map<string, SelectableListOption>, initialIds: string[] = []) => {
  const [selectedIds, setSelectedIds] = useState<string[]>(initialIds);
  const knownOptionsMap = useRef<Map<string, SelectableListOption>>(new Map());

  optionsMap.forEach((option, id) => {
    knownOptionsMap.current.set(id, option);
  });

  const selectedItems = useMemo(
    () =>
      selectedIds.map((id) => knownOptionsMap.current.get(id)).filter((item): item is SelectableListOption => !!item),
    [selectedIds, optionsMap],
  );

  const handleSelectionChange = useCallback((newSelectedIds: string[]) => {
    setSelectedIds(newSelectedIds);
  }, []);

  const reset = useCallback(() => {
    setSelectedIds([]);
  }, []);

  return {
    selectedIds,
    selectedItems,
    handleSelectionChange,
    reset,
  };
};
